export default __webpack_public_path__ + "static/media/undraw_add_files_re_v09g.91bdd1bc.svg";